export default {
      id: "pay_mastercard-usage",
      viewBox: "0 0 52 40",
      url: __webpack_public_path__ + "sprite.svg#pay_mastercard",
      toString: function () {
        return this.url;
      }
    }